<template>
  <div>
    <RightSidebar :isActive.sync="isActive" :closeable="false">
      <template #header>
        <img width="40" :src="ProductIcon" class="mr-4" />
        <div>
          <h4>{{ table && !table.isNonTable ? "Table" : "Non-Table" }}</h4>
          <small v-if="table">{{ table.name }}</small>
        </div>
      </template>

      <template #content>
        <div v-if="table">
          <section class="px-6 mt-4 grid grid-cols-2 gap-x-8">
            <SidebarItem label="Name">
              <vs-input class="w-full" v-model="table.name" />
            </SidebarItem>

            <SidebarItem label="Is round?">
              <vs-select v-model="table.isRound" class="w-full">
                <vs-select-item
                  :key="item.value"
                  :value="item.value"
                  :text="item.name"
                  v-for="item in [
                    { value: false, name: 'No' },
                    { value: true, name: 'Yes' }
                  ]"
                />
              </vs-select>
            </SidebarItem>

            <SidebarItem label="Is rotated 45 degrees?">
              <vs-select v-model="table.isRotated" class="w-full">
                <vs-select-item
                  :key="item.value"
                  :value="item.value"
                  :text="item.name"
                  v-for="item in [
                    { value: false, name: 'No' },
                    { value: true, name: 'Yes' }
                  ]"
                />
              </vs-select>
            </SidebarItem>

            <SidebarItem label="Item type">
              <vs-select v-model="table.isNonTable" class="w-full">
                <vs-select-item
                  :key="item.value"
                  :value="item.value"
                  :text="item.name"
                  v-for="item in [
                    { value: false, name: 'Table' },
                    { value: true, name: 'Non-table' }
                  ]"
                />
              </vs-select>
            </SidebarItem>

            <SidebarItem label="Guest capacity" v-if="!table.isNonTable">
              <NumberInput v-model="table.guestCapacity" unit="guests" :min="0" />
            </SidebarItem>
          </section>
        </div>
      </template>

      <template #footer>
        <vs-button @click="isActive = false"> Ok </vs-button>
        <vs-button
          color="danger"
          type="border"
          class="ml-2"
          @click="
            $emit('onClickRemoveTable', table);
            isActive = false;
          "
        >
          Remove
        </vs-button>
      </template>
    </RightSidebar>
  </div>
</template>

<script>
import ProductIcon from "@/assets/images/product-icon.png";
import RightSidebar from "@/components/Custom/RightSidebar.vue";
import SidebarItem from "@/components/Custom/SidebarItem.vue";
import NumberSelectInput from "@/components/Custom/NumberSelectInput.vue";
import NumberInput from "@/components/Custom/NumberInput.vue";

export default {
  components: {
    RightSidebar,
    SidebarItem,
    NumberSelectInput,
    NumberInput
  },
  data() {
    return {
      ProductIcon,
      isActive: false,
      table: null
    };
  },
  emits: ["onClickRemoveTable"],
  methods: {
    async show(table) {
      this.isActive = true;
      this.table = table;
    }
  }
};
</script>
